import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import styles from "./index.module.scss";

const CustomInfiniteScroll = ({
  children,
  LoadingScreen,
  getRecords,
  dataLength,
  hasMore,
  className,
  endMessage,
}) => {
  const handleNext = () => {
    if (hasMore) {
      getRecords(); // Ensure the passed in function is called
    } else {
    }
  };

  return (
    <InfiniteScroll
      dataLength={dataLength || 0}
      next={handleNext} // Ensure `next` is called
      hasMore={hasMore}
      loader={LoadingScreen}
      style={{
        overflowY: "auto", // Allow scrolling to trigger infinite scroll
        height: "auto",
        display: "grid",
        gap: "20px",
      }}
      className={`${styles.infinite} ${className}`}
      scrollThreshold={0.95} // Trigger earlier for testing
      scrollableTarget="scrollableDiv"
      endMessage={endMessage}
    >
      {children}
    </InfiniteScroll>
  );
};

export default CustomInfiniteScroll;
